import { Box, Button, Center, Grid, GridItem } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import JsonRender from "../JsonRender";
import { useRive, useStateMachineInput } from "@rive-app/react-canvas";
import { STATE_MACHINE_NAME } from "./Stepper";

export type TabButtonProps = {
  gridColumns: number;
  sections?: IConfig[][];
  tabs: string[];
  onChange?: (currentTabIndex: number) => void;
  disabledTabsIndexs?: number[];
  width?: string;
  defaultIndex?: number;
  riveSrc?: string;
  riveAnimateInitialState?: number;
  riveAnimationHeight?: string;
  riveAnimationWidth?: string;
  riveAnimationPosition?: "above-explanation" | "below-explanation";
};

const TabsButtons = ({
  gridColumns = 2,
  onChange,
  tabs,
  disabledTabsIndexs = [],
  width = "full",
  defaultIndex = 0,
  sections,
  riveSrc,
  riveAnimateInitialState,
  riveAnimationWidth,
  riveAnimationPosition,
  riveAnimationHeight,
}: TabButtonProps) => {
  const [tabIndex, setTabIndex] = useState<number | null>(defaultIndex ?? null);
  const { rive, RiveComponent } = useRive({
    src: riveSrc,
    stateMachines: STATE_MACHINE_NAME,
    autoplay: true,
  });
  const isPlayingInput = useStateMachineInput(
    rive,
    STATE_MACHINE_NAME,
    "step",
    riveAnimateInitialState ?? 0
  );

  const handleChanage = (newIndex: number) => {
    setTabIndex(newIndex);
    if (onChange) {
      onChange(newIndex);
    }
  };

  useEffect(() => {
    if (isPlayingInput && tabIndex !== null) {
      isPlayingInput.value = (riveAnimateInitialState ?? 0) + tabIndex;
    }
  }, [tabIndex, rive, riveAnimateInitialState, isPlayingInput]);

  const generateGridTemplateColumns = (gridColumns: number) => {
    return Array(gridColumns).fill(`1fr`).join(" ");
  };

  console.log(tabIndex);

  const riveAnaimtion = (
    <Center>
      <RiveComponent
        style={{
          width: riveAnimationWidth ?? "100%",
          height: riveAnimationHeight ?? "15rem",
        }}
      />
    </Center>
  );

  return (
    <Box>
      {riveSrc &&
        (riveAnimationPosition === "above-explanation" ||
          !riveAnimateInitialState) &&
        riveAnaimtion}
      {sections &&
        sections.map((elems, eidx) => (
          <Box key={eidx} display={tabIndex === eidx ? "block" : "none"}>
            <JsonRender mode="view" content={elems} />
          </Box>
        ))}

      {riveSrc &&
        riveAnimationPosition === "below-explanation" &&
        riveAnaimtion}

      <Center>
        <Grid
          gap={"1rem"}
          my={"1rem"}
          flexDir="row"
          gridTemplateColumns={generateGridTemplateColumns(gridColumns)}
        >
          {tabs &&
            tabs.map((title, index) => (
              <GridItem
                key={index}
                cursor={
                  disabledTabsIndexs.includes(index) ? "not-allowed" : "pointer"
                }
                opacity={disabledTabsIndexs.includes(index) ? 0.5 : 1}
              >
                {disabledTabsIndexs.includes(index) || tabIndex === index ? (
                  <Button
                    size={{ base: "sm", md: "md" }}
                    borderRadius={".4rem"}
                    width={width}
                    variant={"secondary"}
                  >
                    {title}
                  </Button>
                ) : (
                  <Button
                    size={{ base: "sm", md: "md" }}
                    width={width}
                    variant={"teronary"}
                    onClick={() => handleChanage(index)}
                  >
                    {title}
                  </Button>
                )}
              </GridItem>
            ))}
        </Grid>
      </Center>
    </Box>
  );
};

export default TabsButtons;
